function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Select, InputNumber } from "antd";
import { Container, Row, Col } from 'react-bootstrap';
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";

var EditBusinessAccountItem = function EditBusinessAccountItem(_ref) {
  var handler = _ref.handler,
      item = _ref.item;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormLoading = _useState2[0],
      setIsFormLoading = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      formError = _useState4[0],
      setFormError = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      formSuccess = _useState6[0],
      setFormSuccess = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      deptOptions = _useState8[0],
      setDeptOptions = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      serviceOptions = _useState10[0],
      setServiceOptions = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      serviceList = _useState12[0],
      setServiceList = _useState12[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    var formData = new FormData();
    formData.append("id", item.id);
    formData.append('label', values.label);
    formData.append('department_id', values.department_id);
    formData.append('base_price', values.base_price);
    formData.append("business_account_medical_item_category_id", values.business_account_medical_item_category_id);
    formData.append('ent_price', values.ent_price);
    formData.append('ins_price', values.ins_price);
    formData.append('standard', values.standard);
    axios.post(Common.baseApiUrl + 'editbusinessaccountitem', formData).then(function (response) {
      if (response.data.status == 200) {
        setFormSuccess('Opération réussie');
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };

  useEffect(function () {
    if (item.business_account_medical_item_category_id != null) form.setFieldsValue({
      business_account_medical_item_category_id: item.business_account_medical_item_category_id
    });
    axios.get(Common.baseApiUrl + 'getdepartments').then(function (response) {
      if (response.data.status == 200) {
        response.data.departments.forEach(function (s) {
          setDeptOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: s.id,
              label: s.label
            }]);
          });
        });
        axios.get(Common.baseApiUrl + "getbusinessaccountmedicalitemcategories/" + Common.currentUser.id).then(function (sresponse) {
          //setServiceOptions([]); 
          setServiceList([]);

          if (sresponse.data.status == 200) {
            sresponse.data.categories.forEach(function (c) {
              setServiceList(function (prev) {
                return [].concat(_toConsumableArray(prev), [c]);
              });
            });

            if (response.data.departments.length > 0) {
              setServiceOptions([]);

              if (sresponse.data.categories.filter(function (cat) {
                return cat.department_id == item.department_id;
              }).length > 0) {
                sresponse.data.categories.filter(function (c) {
                  return c.department_id == item.department_id;
                }).forEach(function (e) {
                  setServiceOptions(function (prev) {
                    return [].concat(_toConsumableArray(prev), [{
                      value: e.id,
                      label: e.label
                    }]);
                  });
                });
              }
            }
          }
        })["catch"](function (error) {})["finally"](function () {});
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      form.setFieldsValue({
        label: item.label,
        base_price: item.base_price,
        ent_price: item.ent_price,
        business_account_medical_item_category_id: item.business_account_medical_item_category_id,
        ins_price: item.ins_price,
        lan_price: item.lan_price,
        department_id: item.department.id,
        standard: item.standard
      });
    });
  }, []);
  useEffect(function () {}, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      form: form,
      onFinish: onFinish,
      children: [formError.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: formError,
          showIcon: true
        })
      }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: formSuccess,
          showIcon: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "label",
        label: "Nom de l'acte/Produit",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "base_price",
            label: "prix de base",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "ent_price",
            label: "prix soci\xE9t\xE9s",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {})
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "ins_price",
            label: "prix assurances",
            rules: [{
              required: true,
              message: 'Ce champs est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "department_id",
            label: "Cat\xE9gorie",
            children: /*#__PURE__*/_jsx(Select, {
              placeholder: "Choisir le service",
              options: deptOptions,
              onChange: function onChange(v) {
                setServiceOptions([]);
                serviceList.filter(function (s) {
                  return s.department_id == v;
                }).forEach(function (ss) {
                  setServiceOptions(function (prev) {
                    return [].concat(_toConsumableArray(prev), [{
                      value: ss.id,
                      label: ss.label
                    }]);
                  });
                });
              },
              rules: [{
                required: true,
                message: 'Ce champs est obligatoire'
              }]
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "business_account_medical_item_category_id",
            label: "Sous-service",
            children: /*#__PURE__*/_jsx(Select, {
              placeholder: "Choisir la cat\xE9gorie",
              options: serviceOptions,
              rules: [{
                required: true,
                message: 'Ce champs est obligatoire'
              }]
            })
          })
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "standard",
        label: "Norme",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          htmlType: "submit",
          disabled: deptOptions.length == 0,
          loading: isFormLoading,
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "Sauvegarder"
          })
        })
      })]
    })
  });
};

export default EditBusinessAccountItem;